import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Navigation } from 'lucide-react';

const ADDRESS = 'Hietasaarenkatu 18, 65100 Vaasa';
const EMBED_URL = `https://maps.google.com/maps?q=${encodeURIComponent(ADDRESS)}&t=&z=16&ie=UTF8&iwloc=&output=embed`;
const DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(ADDRESS)}`;

const MapSection = () => {
  return (
    <section className="relative py-16 md:py-24 bg-[#F5F3EF]" data-testid="map-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="text-center mb-10">
          <p className="text-[#C97A2B] text-xs tracking-[0.3em] uppercase mb-3">Find Us</p>
          <h2
            className="text-3xl md:text-5xl text-[#2F2F2F] leading-tight mb-3"
            style={{ fontFamily: "'DM Serif Display', Georgia, serif" }}
          >
            In the heart of <span className="italic text-[#C97A2B]">Vaasa</span>
          </h2>
          <p className="text-[#6B705C] text-sm md:text-base">
            Hietasaarenkatu 18, 65100 Vaasa — a short walk from the city centre.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.8 }}
          className="relative rounded-3xl overflow-hidden shadow-2xl border border-[#D9D9D6] bg-white"
          data-testid="map-embed-wrapper"
        >
          <div className="relative w-full aspect-[16/9] md:aspect-[21/9]">
            <iframe
              title="Sunsari Restaurant · Vaasa · Google Map"
              src={EMBED_URL}
              className="absolute inset-0 w-full h-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              data-testid="map-iframe"
            />
          </div>

          {/* Overlay info card */}
          <div className="absolute bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-auto md:max-w-sm bg-white/95 backdrop-blur-md rounded-2xl px-5 py-4 shadow-xl border border-white flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-[#C97A2B]/15 border border-[#C97A2B]/25 flex items-center justify-center flex-shrink-0">
              <MapPin className="w-4 h-4 text-[#C97A2B]" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[10px] uppercase tracking-widest text-[#6B705C] font-semibold">Sunsari Restaurant</p>
              <p className="text-[#2F2F2F] text-sm font-medium leading-tight mt-0.5">Hietasaarenkatu 18</p>
              <p className="text-[#6B705C] text-xs leading-tight">65100 Vaasa, Finland</p>
              <a
                href={DIRECTIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 mt-2 text-[#C97A2B] hover:text-[#B65A3A] text-xs font-semibold"
                data-testid="get-directions-btn"
              >
                <Navigation className="w-3 h-3" /> Get directions
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MapSection;
